import MsNotify from 'src/plugins/ms-notify.plugin'

export default ({ Vue }) => {
  Vue.prototype.$msNotify = MsNotify
}
